export * from "./partner-portfolio-list-template";
